import React from 'react';
import { motion } from 'framer-motion';
import { Wallet } from 'lucide-react';
import { DynamicWidget } from '@dynamic-labs/sdk-react-core';

const AuthPage = () => {
  return (
    <div className="min-h-screen bg-[#030014] relative overflow-hidden flex items-center justify-center">
      {/* Background Effects */}
      <div className="absolute inset-0 dark-mesh" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#7000FF] opacity-20 blur-[120px] rounded-full" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 w-full max-w-md px-6"
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center">
            <Wallet className="w-7 h-7 text-white" />
          </div>
          <span className="text-3xl font-primary font-bold text-white">CRYPTOPAY</span>
        </div>

        {/* Dynamic Auth Widget */}
        <div className="glass-card p-8 rounded-2xl flex flex-col items-center">
          <h2 className="text-3xl font-primary font-bold text-white mb-2 text-center">
            WELCOME
          </h2>
          <p className="text-gray-400 text-center mb-6 font-secondary">
            Sign in or create your account
          </p>
          <DynamicWidget />
        </div>
      </motion.div>
    </div>
  );
};

export default AuthPage;
